import {
    CORE_LOAD_DRAWING_INFORMATION_REQUEST,
    CORE_LOAD_DRAWING_INFORMATION_SUCCESS,
    CORE_LOAD_DRAWING_INFORMATION_FAILURE,

    CORE_SEARCH_DRAWING_REQUEST,
    CORE_SEARCH_DRAWING_SUCCESS,
    CORE_SEARCH_DRAWING_FAILURE,

    REQUEST_STATE
} from '../types'
const requestState = REQUEST_STATE

export default {
    drawing: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_DRAWING_INFORMATION_REQUEST:
                return state
            case CORE_LOAD_DRAWING_INFORMATION_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) { 
                        return data
                    }
                    return {}
                } else return {}
            case CORE_LOAD_DRAWING_INFORMATION_FAILURE:
                return {}
            default:
                return state
        }
    },
    drawings: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SEARCH_DRAWING_REQUEST:
                return state
            case CORE_SEARCH_DRAWING_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_SEARCH_DRAWING_FAILURE:
                return []
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/drawing.js